import { ColorableSVG } from "../ColorableSVG";
import { AssembleIconProps } from "../types";

export const SuccessColorIcon = ({
  height = "16px",
  width = "17px",
  ...props
}: AssembleIconProps): JSX.Element => (
  <ColorableSVG {...props}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.5" cy="8" r="7" fill="url(#paint0_linear_2998_89902)" />
      <path d="M11.5 6.5L7.5 10.5L11.5 6.5Z" fill="#0A2440" />
      <path
        d="M11.5 6.5L7.5 10.5"
        stroke="#EEF5FB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.5 10.5L5.5 8.5L7.5 10.5Z" fill="#0A2440" />
      <path
        d="M7.5 10.5L5.5 8.5"
        stroke="#EEF5FB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2998_89902"
          x1="4.825"
          y1="5.2"
          x2="10.775"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#17BD54" />
          <stop offset="1" stopColor="#089562" />
        </linearGradient>
      </defs>
    </svg>
  </ColorableSVG>
);
